export default "__VITE_ASSET__CJ1smTa9__"